import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';

// Estilos en línea con la paleta de marca
const s = {
  // Colores de marca
  rosa:     '#F5B8A0',
  ocre:     '#C4956A',
  teal:     '#2D4F4A',
  crema:    '#FAF7F4',
  rosaClaro:'#FDF0EB',

  page: {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #FAF7F4 0%, #FDF0EB 50%, #F5E8DF 100%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '1rem',
    fontFamily: "'MyriadPro', 'Helvetica Neue', Arial, sans-serif",
  },
  card: {
    background: '#fff',
    borderRadius: '24px',
    boxShadow: '0 20px 60px rgba(196,149,106,0.15)',
    padding: '2.5rem',
    width: '100%',
    maxWidth: '420px',
  },
  logoWrap: {
    textAlign: 'center',
    marginBottom: '2rem',
  },
  logoImg: {
    height: '90px',
    objectFit: 'contain',
    marginBottom: '0.75rem',
  },
  subtitle: {
    color: '#C4956A',
    fontSize: '0.85rem',
    fontWeight: 400,
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
  },
  label: {
    display: 'block',
    fontSize: '0.82rem',
    fontWeight: 600,
    color: '#2D4F4A',
    marginBottom: '0.4rem',
    letterSpacing: '0.03em',
  },
  input: {
    width: '100%',
    padding: '0.7rem 1rem',
    border: '1.5px solid #E8D5C4',
    borderRadius: '10px',
    fontSize: '0.95rem',
    color: '#2D4F4A',
    outline: 'none',
    transition: 'border-color 0.2s',
    fontFamily: "'MyriadPro', Arial, sans-serif",
    background: '#FAF7F4',
  },
  btn: {
    width: '100%',
    padding: '0.85rem',
    background: 'linear-gradient(135deg, #C4956A, #D4A87A)',
    border: 'none',
    borderRadius: '12px',
    color: '#fff',
    fontSize: '1rem',
    fontWeight: 700,
    letterSpacing: '0.04em',
    cursor: 'pointer',
    marginTop: '0.5rem',
    transition: 'opacity 0.2s, transform 0.1s',
    fontFamily: "'MyriadPro', Arial, sans-serif",
  },
  error: {
    background: '#FEE2E2',
    color: '#DC2626',
    borderRadius: '10px',
    padding: '0.7rem 1rem',
    fontSize: '0.87rem',
    marginBottom: '1rem',
    textAlign: 'center',
  },
  divider: {
    height: '1px',
    background: 'linear-gradient(to right, transparent, #E8D5C4, transparent)',
    margin: '1.5rem 0',
  },
};

export default function LoginPage() {
  const { login, loading, error } = useAuth();
  const [email, setEmail]   = useState('');
  const [pass, setPass]     = useState('');
  const [showPass, setShow] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    await login(email, pass);
  };

  return (
    <div style={s.page}>
      <div style={s.card}>
        {/* Logo principal */}
        <div style={s.logoWrap}>
          <img
            src="/images/logo-horizontal.png"
            alt="Dani Lopera Psicóloga"
            style={s.logoImg}
          />
          <p style={s.subtitle}>Sistema de Gestión · Consultorio</p>
        </div>

        {error && <div style={s.error}>{error}</div>}

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '1.1rem' }}>
            <label style={s.label}>Correo electrónico</label>
            <input
              style={s.input}
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="correo@ejemplo.com"
              required
              onFocus={e => (e.target.style.borderColor = '#C4956A')}
              onBlur={e => (e.target.style.borderColor = '#E8D5C4')}
            />
          </div>
          <div style={{ marginBottom: '1.5rem' }}>
            <label style={s.label}>Contraseña</label>
            <div style={{ position: 'relative' }}>
              <input
                style={s.input}
                type={showPass ? 'text' : 'password'}
                value={pass}
                onChange={e => setPass(e.target.value)}
                placeholder="••••••••"
                required
                onFocus={e => (e.target.style.borderColor = '#C4956A')}
                onBlur={e => (e.target.style.borderColor = '#E8D5C4')}
              />
              <button
                type="button"
                onClick={() => setShow(!showPass)}
                style={{
                  position: 'absolute', right: '0.75rem', top: '50%',
                  transform: 'translateY(-50%)', background: 'none',
                  border: 'none', cursor: 'pointer', color: '#C4956A',
                  fontSize: '0.8rem', fontWeight: 600,
                }}
              >
                {showPass ? 'Ocultar' : 'Ver'}
              </button>
            </div>
          </div>
          <button
            style={{ ...s.btn, opacity: loading ? 0.7 : 1 }}
            type="submit"
            disabled={loading}
          >
            {loading ? 'Ingresando...' : 'Ingresar al sistema'}
          </button>
        </form>

        <div style={s.divider} />

        <div style={{ textAlign: 'center' }}>
          <img
            src="/images/isotipo.png"
            alt="DL"
            style={{ height: '36px', opacity: 0.45 }}
          />
        </div>
      </div>
    </div>
  );
}
